module.exports = __webpack_public_path__ + "img/bage.14f2f9ab.svg";